import {SET_PERSONAL_INFO, SET_USER_ID, ZOOM_IMAGE} from "./types";
import {createAction} from "@reduxjs/toolkit";

export const setUserId = createAction(SET_USER_ID, function (userId: number){
  return {
    payload: userId
  }
})

export const setUserInfo = createAction(SET_PERSONAL_INFO, function (payload: any) {
  return {
    payload: payload
  }
});

export const zoomImage = createAction(ZOOM_IMAGE, (payload:any) => {
  return {
    payload: payload
  }
})
